const BaseComponent = require('base/base-component');

class TopLine extends BaseComponent {
  init () {
    $(document).ready(() => {
      window.skyConfig = {
        onReady: (data) => {
          if (data.user) {
            window.currentUserIdentity = data.user;
          }
          if (data.hrefs) {
            window.envHref = data.hrefs;
          }
        }
      };
    });
  }
}
module.exports = TopLine;
